"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestPassValue = void 0;
const TestPassSymbol = Symbol("TestPass Type");
exports.TestPassValue = { [TestPassSymbol]: true };
//# sourceMappingURL=Tests.js.map